export enum ConnectorStatus {
  Available = 'Available',
  Preparing = 'Preparing',
  Charging = 'Charging',
  Suspended_EV = 'SuspendedEV',
  Suspended_EVSE = 'SuspendedEVSE',
  Finishing = 'Finishing',
  Reserved = 'Reserved',
  Unavailable = 'Unavailable',
  Faulted = 'Faulted',
}

export enum StationStatus {
  Active = 'active',
  Inactive = 'inactive',
  In_use = 'in_use',
}
